module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/folder-cloud-138bc29ca0a987f975cf8be6fa8a02d8.svg";